/**
 * El QueryClient ÚNICO de la aplicación.
 *
 * 🔴 Existía dos veces, y eso dejó la red de seguridad INERTE durante meses:
 * main.tsx creó su cliente el 2026-07-28 con el `MutationCache.onError` (el
 * incidente del bono que fallaba en silencio), pero router.tsx conservaba el
 * cliente de Sprint 10 y su provider —más interno— era el que ganaba para toda
 * la aplicación. Medido el 2026-10-01: el caso VC-48 del plan M01 (emitir sin
 * CAF no mostraba nada) ocurrió con la red supuestamente activa. Un solo
 * cliente en un solo módulo es lo que impide que vuelva a pasar.
 */
import { MutationCache, QueryClient } from '@tanstack/react-query'
import { handleMutationError } from '@/lib/mutationErrorHandler'

export const queryClient = new QueryClient({
  // Red de seguridad: una mutación que falla sin manejo local muestra el
  // mensaje del backend (zen/exceptions.py lo manda listo para mostrar).
  // El manejo de duplicados vive en mutationErrorHandler.
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => handleMutationError(error, mutation),
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
})
